import React, { useEffect } from 'react';

/**
 * GoogleAnalytics — injects the gtag.js script and initializes GA4
 * using the VITE_GA_MEASUREMENT_ID environment variable.
 * Renders nothing if the measurement ID is not configured.
 */
const GoogleAnalytics = () => {
  const measurementId = import.meta.env?.VITE_GA_MEASUREMENT_ID;

  useEffect(() => {
    if (!measurementId || measurementId === 'your-google-analytics-id-here') return;

    // Inject the gtag script tag
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head?.appendChild(script1);

    // Initialize dataLayer and gtag
    window.dataLayer = window.dataLayer || [];
    function gtag(...args) { window.dataLayer?.push(args); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', measurementId);
  }, [measurementId]);

  return null;
};

export default GoogleAnalytics;
